import { useLang } from '@/i18n';
import EcoImg from 'eco-design/base/eco-img';
import css from './index.module.scss';
import { ItfItem } from './type';
import { useProductState } from '../../ProductProvider';
import { IPageStatus } from '../../config/IPageStatus';
import { calendar, gift, profile, question } from './icons';
import EcoLink from 'eco-design/base/eco-link';
import gtm from 'eco-design-reliance/gtm';
import { useEffect, useState } from 'react';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';

const Dialog_D = dynamic(() => import('./Dialog'));

const D: React.FC = () => {
    const { t } = useLang('ces2026.D');
    const { query, asPath } = useRouter();
    const { popup = '' } = query;
    const { pageStatus } = useProductState();
    const IS_STAGE_1 = pageStatus === IPageStatus.STAGE_1;
    const [visible, setVisible] = useState<boolean>(false);
    const items: ItfItem[] = [
        {
            name: t('item1_name'),
            text: t('item1_text'),
            avatar: 'https://websiteoss.ecoflow.com/upload/image/1765274087836/D1.jpg',
        },
        {
            name: t('item2_name'),
            text: t('item2_text'),
            avatar: 'https://websiteoss.ecoflow.com/upload/image/1765274088640/D2.jpg',
        },
        {
            name: t('item3_name'),
            text: t('item3_text'),
            avatar: 'https://websiteoss.ecoflow.com/upload/image/1765274088012/D3.jpg',
        },
        {
            name: t('item4_name'),
            text: t('item4_text'),
            avatar: 'https://websiteoss.ecoflow.com/upload/image/1765274088214/D4.jpg',
        },
        {
            name: t('item5_name'),
            text: t('item5_text'),
            avatar: 'https://websiteoss.ecoflow.com/upload/image/1765274088428/D5.jpg',
        },
    ];

    const handle_GTM_102 = () => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'activity_join',
            button_name: t('event_btn_join'),
            __btn_id1: 'ces-2026-D',
            __btn_id2: 'Join the Event',
            __btn_type: 'common',
        });
    };

    const handleJoinEvent = () => {
        setVisible(true);
        handle_GTM_102();
    };

    useEffect(() => {
        if (popup === '1' && asPath?.endsWith('#ambassadors') && IS_STAGE_1) {
            setVisible(true);
        }
    }, [popup, asPath]);

    // useEffect(() => {
    //     if (typeof window !== 'undefined') {
    //         const scenes: any = [];
    //         const el: HTMLDivElement | null = document.querySelector('.ces-2026-C');
    //         if (el) {
    //             scenes.push(
    //                 AniContainer.create({
    //                     triggerElement: el,
    //                     triggerHook: 1,
    //                     offset: el.offsetHeight,
    //                     duration: '50%',
    //                     syncFromTo: [
    //                         ['.ces-2026-D', { y: window.innerHeight / 2 }, { y: 0 }],
    //                         ['.ces-2026-C', { opacity: 1 }, { opacity: 0 }],
    //                     ],
    //                 }),
    //             );
    //         }
    //         return () => scenes?.forEach((scene: any) => scene && scene?.destroy());
    //     }
    // }, []);

    return (
        <div id="ambassadors" className={`ces-2026-D ${css.section} GtmModuleData-section`} data-section-id={'ces-2026-D'}>
            <div className="box-inner">
                <div className="info">
                    <h2 className="title">{t('title')}</h2>
                </div>
                <ul className="items">
                    {items.map((item: ItfItem, i: number) => (
                        <li className="item" key={i}>
                            <div className="item-img">
                                <EcoImg pc={item.avatar} />
                            </div>
                            <div className="item-info">
                                <p className="item-name name">{item.name}</p>
                                <p className="item-text text">{item.text}</p>
                            </div>
                        </li>
                    ))}
                </ul>
                <div className={`event`}>
                    <div className="avatar-box">
                        <div className="avatar">
                            {IS_STAGE_1 ? question : <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1767066412007/awards.png" />}
                        </div>
                        {IS_STAGE_1 && (
                            <div className="date">
                                {calendar}
                                <span>{t('event_date')}</span>
                            </div>
                        )}
                    </div>
                    <div className={`event-info ${IS_STAGE_1 ? 'gap1' : 'gap2'}`}>
                        <p className="event-title">{t('event_title')}</p>
                        {IS_STAGE_1 ? (
                            <>
                                <div className="gift-slogan">
                                    <span className="gift">{gift}</span>
                                    <span className="slogan">{t('event_slogan')}</span>
                                </div>
                                <p className="text">{t('event_text')}</p>
                                <button className="event-btn GtmModuleData-btn-common" data-btn-id="Join the Event" onClick={handleJoinEvent}>
                                    {t('event_btn_join')}
                                </button>
                            </>
                        ) : (
                            <>
                                <p className="text text-award">{t('event_desc')}</p>
                                <div className="award-reault">
                                    <span className="profile">{profile}</span>
                                    <span className="name user-name">{t('event_award_name')}</span>
                                </div>
                                <EcoLink
                                    className="event-btn GtmModuleData-btn-href"
                                    href="#ces-2026-I"
                                    dataLayer={{
                                        __btn_id1: 'ces-2026-D',
                                        __btn_id2: '#ces-2026-I',
                                        __btn_type: 'href',
                                    }}
                                >
                                    {t('event_btn_award')}
                                </EcoLink>
                            </>
                        )}
                    </div>
                </div>
            </div>
            {visible && <Dialog_D visible={visible} callback={() => setVisible(false)} />}
        </div>
    );
};

export default D;
